import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Paper,
  Tabs,
  Tab
} from "@material-ui/core";
import AllClientsTab from "./clientData/AllClientsTab";
import AllRequestsTab from "./clientData/AllRequestsTab";
import { useTabRoute } from "../useTabRoute";

const TAB_SLUGS = ["clients", "requests"];

const useStyles = makeStyles((theme) => ({
  section: {
    padding: 0,
  },
  paper: {
    boxShadow: "none",
    border: "1px solid #E1E6F1",
    backgroundColor: "#ffffff",
  },
  tabsContainer: {
    borderBottom: "1px solid #E1E6F1",
    backgroundColor: "#F3F5F7",
    padding: theme.spacing(0, 2),
    "& .MuiTabs-indicator": {
      backgroundColor: "#1A1E24",
    },
    "& .MuiTab-root": {
      color: "#54606F",
      fontWeight: 500,
      fontSize: "16px",
      textTransform: "none",
      "&.Mui-selected": {
        color: "#1A1E24",
        fontWeight: 600,
      },
      "&:hover": {
        color: "#1A1E24",
      },
    },
  },
  tabContent: {
    padding: theme.spacing(3),
    minHeight: "400px",
    backgroundColor: "#ffffff",
  },
}));

const ClientDataSection = () => {
  const classes = useStyles();
  const [activeTab, selectTab] = useTabRoute(TAB_SLUGS);

  const handleTabChange = (event, newValue) => {
    selectTab(newValue);
  };

  return (
    <Box className={classes.section}>
      <Paper className={classes.paper}>
        <Box className={classes.tabsContainer}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
          >
            <Tab label="Все клиенты" />
            <Tab label="Все запросы" />
          </Tabs>
        </Box>

        <Box className={classes.tabContent}>
          {activeTab === 0 && <AllClientsTab />}
          {activeTab === 1 && <AllRequestsTab />}
        </Box>
      </Paper>
    </Box>
  );
};

export default ClientDataSection;